import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeAdminSidebar } from "../../app/adminSidebarSlice";
import SidebarAdmin from "../AdminComponents/SidebarAdmin";
import NavbarAdmin from "../AdminComponents/NavbarAdmin";
import InfoBarAdmin from "../AdminComponents/InfoBarAdmin";
import { DESIGN_TOKENS } from "../../designSystem/tokens";

const MainAdmin = ({ children }) => {
  const dispatch = useDispatch();
  const { isOpen, collapsed } = useSelector((state) => state.adminSidebar);
  const sidebarWidth = collapsed
    ? DESIGN_TOKENS.layout.sidebarCollapsed
    : DESIGN_TOKENS.layout.sidebarExpanded;

  return (
    <div
      className="ds-app flex h-[100dvh] overflow-hidden"
      style={{
        background: "var(--bg-app)",
        fontFamily: DESIGN_TOKENS.typography.fontFamily,
      }}
    >
      {/* Desktop sidebar */}
      <aside
        className="hidden lg:flex flex-col flex-shrink-0 ds-sidebar overflow-hidden"
        style={{
          width: sidebarWidth,
          zIndex: 20,
          transition: "width 0.22s ease",
        }}
      >
        <SidebarAdmin collapsed={collapsed} />
      </aside>

      {/* Mobile drawer + overlay */}
      <div
        className="fixed inset-0 lg:hidden"
        style={{
          zIndex: DESIGN_TOKENS.layout.drawerZ,
          pointerEvents: isOpen ? "auto" : "none",
        }}
        aria-hidden={!isOpen}
      >
        <div
          className="ds-overlay"
          onClick={() => dispatch(closeAdminSidebar())}
          style={{
            opacity: isOpen ? 1 : 0,
            transition: "opacity 0.2s ease",
            zIndex: DESIGN_TOKENS.layout.overlayZ,
          }}
        />
        <aside
          className="absolute top-0 left-0 h-full flex flex-col bg-[var(--surface-color)] shadow-md"
          style={{
            width: DESIGN_TOKENS.layout.sidebarExpanded,
            transform: isOpen ? "translateX(0)" : "translateX(-105%)",
            transition: "transform 0.22s ease",
            zIndex: DESIGN_TOKENS.layout.drawerZ,
          }}
        >
          <SidebarAdmin mobile />
        </aside>
      </div>

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <div className="flex-shrink-0 z-30 bg-[var(--surface-color)]">
          <NavbarAdmin />
        </div>
        <main className="flex-1 overflow-y-auto no-scrollbar ds-page">
          <div className="mb-4">
            <InfoBarAdmin />
          </div>
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainAdmin;
